import { render, staticRenderFns } from "./ModalFixingQuantity.vue?vue&type=template&id=51504277&"
import script from "./ModalFixingQuantity.vue?vue&type=script&lang=js&"
export * from "./ModalFixingQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports